import React, { useRef, useState, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import "../../case.scss"
import { Button, Form, Input, message, Progress, Upload } from "antd";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useVideoModel } from "../videoModel";
import { IContentDetail, LinkType } from "../../contentTypes";
import { contentService, COSUpFileToken, UpFileToken } from "../../contentService";
import { RcCustomRequestOptions, UploadFile } from "antd/lib/upload/interface";
import * as qiniu from 'qiniu-js'
import BMF from 'browser-md5-file';
import COS from "cos-js-sdk-v5";
import axios from "axios";
import useGlobalModel from "@/model/globalModel";

export const DetailsBox = () => {
    const { addFormVal, addMd5FormVal, editFormVal, editMd5FormVal, insertDetail, editDetail,
        setAddMd5FormVal, setEditMd5FormVal, getDetailEditOne,
        resetAddCatch, resetEditCatch,
        setSelectedRow,
        setSelectedRowKeys,
        loadData,
    } = useVideoModel();
    const { user } = useGlobalModel()
    const { selectedNavId, getSelectedNavState, findNav, replaceNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode } = detailsInfo;
    const [linkType, setlinkType] = useState<LinkType>()
    const [form] = Form.useForm();
    const [cosData, setCosData] = useState<COSUpFileToken>({
        requestId: "",
        startTime: 0,
        expiration: "",
        expiredTime: 0,
        credentials: {
            sessionToken: "",
            tmpSecretId: "",
            tmpSecretKey: "",
        }
    })
    const [videoUrl, setVideoUrl] = useState("")
    const [percent, setPercent] = useState({ parsePercent: 0, uploadPercent: 0 }) // MD5生成进度

    useEffect(() => {
        if (!Object.keys(editFormVal).length && mode === "edit") {
            getDetailEditOne(id, mode)
        }
    }, [id, mode])

    useEffect(() => {
        return () => {
            !findNav("4-2-1") && resetAddCatch(mode) && formRef.current?.resetFields();
            !findNav("4-2-2") && resetEditCatch(mode) && formRef.current?.resetFields();
        }
    }, [selectedNavId])

    useEffect(() => {
        setVideoUrl(mode === "add" ? (addFormVal.externalUrl ?? "") : (editFormVal.externalUrl ?? ""))
    }, [addFormVal.externalUrl, editFormVal.externalUrl])

    useEffect(() => {
        setlinkType(mode === "add" ? addFormVal.linkType as LinkType : editFormVal.linkType as LinkType)
    }, [addFormVal.linkType, editFormVal.linkType])

    const formRef = useRef<IYhFormRef>();
    const imgFormRef = useRef<IYhFormRef>();
    const formConfig: IYhForm<IContentDetail> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "add" ? { ...addFormVal, createUser: user.userName } : editFormVal,
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "文章标题",
                fieldName: "title",
                rules: [{ required: true, message: "请输入文章标题" }]
            },
            {
                type: FormItemTypeEnum.TextArea,
                span: 24,
                fieldLabel: "描述",
                fieldName: "desc",
                rules: [{ required: true, message: "请输入描述" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "置顶",
                fieldName: "status",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "视频类型",
                fieldName: "linkType",
                span: 24,
                options: [
                    {
                        label: '本地',
                        value: 'local'
                    },
                    {
                        label: '外部链接',
                        value: "external"
                    }
                ],
                onSelectChange: (value) => {
                    setlinkType(value as LinkType)
                }
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "推荐到首页",
                fieldName: "homeFlag",
                span: 24,
            },
        ]
    }
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === "add" ? setAddMd5FormVal(formValues.image) : setEditMd5FormVal(formValues.image)
    }
    const imgformConfig: IYhForm<IContentDetail> = {
        formRef: imgFormRef,
        labelCol: { span: 3 },
        formValues: {},
        items: [
            //     {
            //         type: FormItemTypeEnum.FileImage,
            //         fieldLabel: "图片上传",
            //         fieldName: "image",
            //         span: 24,
            //         md5List: mode === "add" ? addMd5FormVal : editMd5FormVal,
            //         onSetFieldsValue
            //     },
        ]
    }
    const onSubmit = () => {
        formRef.current?.validateFields().then(async (res: any) => {
            let { status, homeFlag, ...params } = res
            const data = {
                ...params,
                status: status ? 1 : 0,
                homeFlag: homeFlag ? 1 : 0,
                type: "video",
                externalUrl: videoUrl,
            }
            if (mode === "add") {
                const retData = await insertDetail(data)
                if (retData) {
                    globalPrompt("message", { text: "国内案例新增成功", type: "success" })
                    setSelectedRow([])
                    setSelectedRowKeys([])
                    goBack();
                }
            } else {
                const retData = await editDetail({
                    ...data,
                    id,
                })
                if (retData) {
                    globalPrompt("message", { text: "国内案例编辑成功", type: "success" })
                    setSelectedRow([])
                    setSelectedRowKeys([])
                    goBack();
                }
            }
        })
    }
    const goBack = async () => {
        await loadData()
        replaceNav(selectedNavId, "4-2")
    }

    useEffect(() => {
        getFileToken()
    }, [])

    const getFileToken = async () => {
        const { retData } = await contentService.getUpFileToken()
        setCosData(retData)
    }
    //富文本扩展上传图片
    const fileUrl = "http://file-2.laoniuche.cn";

    // 设置next,error,complete对应的操作，分别处理相应的进度信息，错误信息，以及完成后的操作
    var error = function (err: any) {
        message.error("上传出错")
    };

    var complete = function (res: { bucket: string; fsize: number; hash: string; key: string; name: string; }) {
        console.log(res);
        message.success("上传成功!")
        setVideoUrl(`${fileUrl}/${res.key}`)
    };

    var next = function (response: any) {
        var chunks = response.chunks || [];
        var total = response.total as { loaded: number; percent: number; size: number; }
        setPercent({ ...percent, uploadPercent: total.percent })
        // var finishedAttr = [];
        // var compareChunks = [] as any[];
        // 这里对每个chunk更新进度，并记录已经更新好的避免重复更新，同时对未开始更新的跳过
        // for (var i = 0; i < chunks.length; i++) {
        //     debugger
        //     if (chunks[i].percent === 0 || finishedAttr[i]) {
        //         continue;
        //     }
        //     if (compareChunks[i].percent === chunks[i].percent) {
        //         continue;
        //     }
        //     if (chunks[i].percent === 100) {
        //         finishedAttr[i] = true;
        //     }
        // $(board)
        //     .find(".fragment-group li")
        //     .eq(i)
        //     .find("#childBarColor")
        //     .css(
        //         "width",
        //         chunks[i].percent + "%"
        //     );
        // }
        // $(board)
        //     .find(".speed")
        //     .text("进度：" + total.percent + "% ");
        // dom_total.css(
        //     "width",
        //     total.percent + "%"
        // );
        // compareChunks = chunks;
    };
    const onUpload = (options: RcCustomRequestOptions) => {
        // console.log(options);
        const bmf = new BMF();
        const file = options.file
        const cos = new COS({
            getAuthorization: (options, callback) => {
                console.log(options);
                contentService.getUpFileToken().then(ret => {
                    const { retData } = ret
                    const { credentials } = retData
                    callback({
                        TmpSecretId: credentials.tmpSecretId,
                        TmpSecretKey: credentials.tmpSecretKey,
                        SecurityToken: credentials.sessionToken,
                        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                        StartTime: retData.startTime, // 时间戳，单位秒，如：1580000000
                        ExpiredTime: retData.expiredTime, // 时间戳，单位秒，如：1580000900
                        ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
                    });
                })
            }
        })



        bmf.md5(options.file, (err: any, md5: string) => {
            console.log('err:', err);
            console.log('md5 string:', md5); // 97027eb624f85892c69c4bcec8ab0f11
            // const fileName = `MD5-${md5}-${file.name}`
            // // 调用sdk上传接口获得相应的observable，控制上传和暂停
            // const observable = qiniu.upload(file, fileName, upFileToken.uptoken, putExtra, {
            //     // const observable = qiniu.upload({ ...file, name: fileName }, fileName, upFileToken.uptoken, putExtra, {
            //     useCdnDomain: true,
            //     disableStatisticsReport: false,
            //     retryCount: 6,
            //     region: qiniu.region.z1,
            //     debugLogLevel: 'INFO'
            // })
            // observable.subscribe({ next, error, complete })
            cos.uploadFile({
                Bucket: 'yhgw-1301309125',
                Region: "ap-beijing",
                // Bucket: 'wuchao-1300269367',
                // Region: "ap-beijing",
                Key: md5,
                Body: file,
                onProgress: (info) => {
                    console.log('upload info: ', info);
                    // loaded: 20971520
                    // percent: 0.09
                    // speed: 3830414.61
                    // total: 221172398
                    setPercent({ ...percent, uploadPercent: parseInt(Number(info.percent) * 100 + '') })
                }
            }, (error, data) => {
                console.log('upload callback:', error, data);
                // Bucket: "yhgw-1301309125"
                // ETag: "\"a86e0cd3c6554e5ee7d9e9015d246007-211\""
                // Key: "a4f13fefc96c1f427f90e68bfea84a5b"
                // Location: "yhgw-1301309125.cos.ap-beijing.myqcloud.com/a4f13fefc96c1f427f90e68bfea84a5b"
                // RequestId: "NjE2ODE2NGRfMzJiMDJhMDlfNWQ1N180OGI0OGZk"
                // UploadId: "16342113562e5d67ec42c91b278bcbd29938cdb8c67b12185243185a93dc106fad41e336b9"
                // headers: { content - type: "application/xml", x - cos - request - id: "NjE2ODE2NGRfMzJiMDJhMDlfNWQ1N180OGI0OGZk" }
                // statusCode: 200
                if (data) {
                    setVideoUrl('https://' + data.Location)
                }
            })
        },
            (progress: number) => {
                console.log('progress number:', Number(progress) * 100);
                setPercent({ ...percent, parsePercent: parseInt(Number(progress) * 100 + '') })
            })
        const putExtra = {
            customVars: {}
        };


    }



    return <YhBox title="视频管理详情">
        <div style={{ display: "flex" }}>
            <div className="form-left">
                <YhForm  {...formConfig} />
                <div className="form-btn">
                    <Button type="link" shape="round" onClick={onSubmit}>发布</Button>
                    <Button type="link" shape="round" onClick={goBack}>返回</Button>
                </div>
            </div>
            <div className="img-right" style={{ display: "flex", flexDirection: "column" }}>
                {
                    linkType === 'local' ?
                        // <YhForm  {...imgformConfig} >
                        //     <FormFileImage
                        //         type={FormItemTypeEnum.FileImage}
                        //         fieldLabel="图片上传"
                        //         fieldName="image"
                        //         rules={[{ required: true, message: "请选择图片" }]}
                        //         md5List={mode === "add" ? addMd5FormVal : editMd5FormVal}
                        //         // onSetFieldsValue={onSetFieldsValue}
                        //         customRequest={onUpload}
                        //     />
                        // </YhForm>
                        <>
                            <Upload
                                accept="video/*"
                                // action={`${fileUrl}/file/uploadFile`}
                                showUploadList={false}
                                fileList={[{
                                    uid: videoUrl,
                                    url: videoUrl
                                } as UploadFile]}
                                customRequest={onUpload}
                            >
                                {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                                <button type="button" className="control-item button upload-button" >上传视频</button>
                            </Upload>
                        </>
                        : <Form
                            form={form}
                            initialValues={mode === "add" ? addFormVal : editFormVal}
                            autoComplete="off"
                        >
                            <div style={{ overflow: 'hidden' }}>
                                <Form.Item
                                    name="externalUrl"
                                    label="链接"
                                >
                                    <Input placeholder="外部链接" onChange={value => setVideoUrl(value.currentTarget.value)} />
                                </Form.Item>
                            </div>
                        </Form>
                }
                {
                    percent.parsePercent ? <>
                        <div>处理进度：</div>
                        <Progress percent={percent.parsePercent} />
                    </> : null
                }
                {
                    percent.uploadPercent ? <>
                        <div>上传进度：</div>
                        <Progress percent={percent.uploadPercent} />
                    </> : null
                }
                <video autoPlay controls src={videoUrl}></video>
            </div>
        </div>
    </YhBox>
}